import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import {
    Avatar,
    CardHeader,
    Chip,
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import useTicketAI from "../../hooks/useTicketAI";
import { stateText } from "../../styles/aerosTokens";

const useStyles = makeStyles((theme) => ({
    // Estilos para o modal da imagem
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8,
        },
    },
    contactName: {
        fontSize: 14,
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    ticketIdTag: {
        fontSize: 13.5,
        fontWeight: 500,
        color: theme.palette.aeros.textTertiary,
        marginLeft: 4,
    },
    contactSubheader: {
        fontSize: 11.5,
        color: theme.palette.text.secondary,
    },
    cardHeader: {
        padding: 0,
        "& .MuiCardHeader-avatar": {
            marginRight: 12,
        },
    },
    headerAvatar: {
        width: 38,
        height: 38,
    },
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
    const classes = useStyles();
    const theme = useTheme();
    const [amount, setAmount] = useState("");
    const { user } = useContext(AuthContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem
    const { iaAtiva } = useTicketAI(ticket);

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar execute outros handlers
        if (contact?.urlPicture) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    const renderCardReader = () => {
        return (
            <CardHeader
                onClick={onClick}
                style={{ cursor: "pointer" }}
                className={classes.cardHeader}
                titleTypographyProps={{ noWrap: true, className: classes.contactName }}
                subheaderTypographyProps={{ noWrap: true, className: classes.contactSubheader }}
                avatar={
                    <Avatar
                        src={contact?.urlPicture}
                        alt="contact_image"
                        className={`${classes.clickableAvatar} ${classes.headerAvatar}`}
                        onClick={handleImageClick}
                    />
                }
                title={
                    <>
                        {(contact?.name && contact.name.length > 12) ?
                            `${contact.name.substring(0, 12)}...` :
                            contact?.name || '(sem contato)'}
                        <span className={classes.ticketIdTag}>#{ticket?.id}</span>
                        {iaAtiva && (
                            <Chip
                                size="small"
                                label={i18n.t("messagesList.header.aiActive")}
                                style={{
                                    marginLeft: 8,
                                    height: 18,
                                    fontSize: 10,
                                    fontWeight: 600,
                                    borderRadius: 5,
                                    padding: "1px 7px",
                                    color: stateText(theme, "#C08BFF", "purple"),
                                    backgroundColor: "rgba(160,68,255,0.12)",
                                }}
                            />
                        )}
                    </>
                }
                subheader={[
                    ticket?.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket?.user?.name}`,
                    contact?.contactWallets && contact.contactWallets.length > 0
                        ? `• ${i18n.t("wallets.wallet")}: ${contact.contactWallets[0].wallet?.name || 'N/A'}`
                        : null
                ].filter(Boolean).join(' ')}
            />
        );
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setAmount(value);
    }

    return (
        <React.Fragment>
            <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                {/* Conteúdo do contato à esquerda */}
                {renderCardReader()}
            </div>

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                        src={contact?.urlPicture} 
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;